import type { TonyteActivity } from '../types';
import { getEventUploaderKind, type EventUploaderKind } from '../utils/eventUploader';
import { useUserProfile } from '../utils/userProfiles';
import { usePublisherVenue } from './useVenueVibes';

/**
 * The avatar shown next to an event wherever its uploader is displayed.
 * Partner events: the partner's picture (venue logo, then account photo).
 * Admin/curated events: '' — callers show the Tonyte logo, never the admin's
 * personal photo. Never trust a stored organizerLogoUrl: editing someone
 * else's event used to stamp the editor's own photo onto it.
 */
export function useEventUploaderImage(activity: TonyteActivity): { kind: EventUploaderKind; image: string } {
  const kind = getEventUploaderKind(activity);
  const uploaderId = kind === 'admin' ? '' : activity.createdBy || activity.hostId || '';
  const uploaderProfile = useUserProfile(uploaderId);
  const publisherVenue = usePublisherVenue(kind === 'partner' ? activity : null, false);
  const image = kind === 'admin'
    ? ''
    : (kind === 'partner' ? publisherVenue?.logoUrl : undefined) || uploaderProfile?.profileImage || '';
  return { kind, image };
}
